import { useState, useMemo } from 'react';
import useGetPublicAssignmentTranscriptionQuery from 'features/publicRoleplay/services/queries/useGetPublicAssignmentTranscription';
import LoadingTranscription from 'features/realplays/Components/ReportResult/LoadingTranscription';
import { Collapse, Avatar } from '@material-ui/core';
import PublicRealPlayHelper from 'features/publicRoleplay/publicRealPlay.helper';
import { SentimentDissatisfied } from '@material-ui/icons';
import classes from 'features/realplays/Components/ReportResult/ReportResult.module.css';
import User from 'infrastructure/User';
import cat from 'assets/cat.jpeg';
import CopyComponent from 'features/realplays/Components/Common/CopyComponent';
import CopyTranscription from 'features/realplays/Components/Common/CopyTranscription';
import DownloadComponent from 'features/realplays/Components/Common/DownloadComponent';
import InputComponent from 'features/realplays/Components/Common/InputComponente';

const PublicTranscription = ({
  assignment_uuid,
  scenario_uuid,
  response_uuid,
  clientName,
  assigned_by_user,
  client_profile_pic,
}) => {
  const [open, setOpened] = useState(false);
  const [search, setSearch] = useState('');
  const handleOpen = () => setOpened((prev) => !prev);

  const { isLoading: isLoadingTranscription } = useGetPublicAssignmentTranscriptionQuery({
    assignment_uuid,
    scenario_uuid,
    response_uuid,
    enabled: !!assignment_uuid && !!scenario_uuid && !!response_uuid,
    clientName,
    userName: 'Guest',
  });
  const { transcription } = PublicRealPlayHelper();

  const handleInputChange = (e) => setSearch(e.target.value);

  const filteredTranscript = useMemo(() => {
    if (!transcription || transcription?.length === 0) return [];
    if (search === '') return transcription;
    return transcription?.filter(
      (item) =>
        item.content.toLowerCase().includes(search.toLowerCase()) ||
        item.role.toLowerCase().includes(search.toLowerCase()) ||
        item.name.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, transcription]);

  return (
    <div>
      <h4>📝 Transcription</h4>
      <Collapse in={open} collapsedSize={210}>
        {isLoadingTranscription ? (
          <LoadingTranscription />
        ) : !transcription || transcription?.length === 0 ? (
          <div className={classes.errorContainer}>
            <div>
              <SentimentDissatisfied fontSize="small" />
              <p style={{ fontSize: '12px' }}>
                We’re unable to get the transcription right. Refresh or try again later.
              </p>
              <p>ERROR CODE 000-000</p>
            </div>
          </div>
        ) : (
          <div className={classes.transcription}>
            <div className={classes.buttonsContainer}>
              <InputComponent value={search} handleChange={handleInputChange} />
              <div className={classes.actions}>
                <CopyTranscription transcription={transcription} />
                <DownloadComponent transcription={transcription} />
              </div>
            </div>
            <div className={classes.columnContainer}>
              {filteredTranscript?.length > 0 ? (
                filteredTranscript?.map((item, index) => (
                  <div
                    className={classes.columnContainer}
                    key={`T-${index}`}
                    style={{ marginBottom: '1rem', gap: '0.2rem', marginLeft: '0.5rem' }}
                  >
                    <div className={classes.imageContainer}>
                      {item?.role === 'user' ? (
                        <>
                          <Avatar
                            className={classes.avatar}
                            alt=""
                            src={assigned_by_user?.profile_pic}
                          >
                            {User.getInitial(assigned_by_user) || 'U'}
                          </Avatar>
                          <p>Guest</p>
                        </>
                      ) : (
                        <>
                          <Avatar
                            className={classes.avatar}
                            alt=""
                            src={client_profile_pic ? client_profile_pic : cat}
                          />
                          <p>{clientName}</p>
                        </>
                      )}
                      <div className={classes.time}>
                        {item?.timestamp.toString().replace('.', ':')}{' '}
                      </div>
                    </div>
                    <div className={classes.rowContainer}>
                      <CopyComponent text={item?.content} />
                    </div>
                  </div>
                ))
              ) : (
                <p style={{ color: '#78909c' }}>No matching results were found</p>
              )}
            </div>
          </div>
        )}
      </Collapse>
      <div className={classes.labelContainer} onClick={handleOpen}>
        {open ? 'Hide' : 'See All'}
      </div>
    </div>
  );
};

export default PublicTranscription;
